// extracted by mini-css-extract-plugin
export var infoItem = "_m5-1";
export var title = "_m5-0";